export default {
  priv: 'pr_manage',
  overviewTitle: 'Afwezigheden',
  detailTitle: 'Afwezigheid',
  deleteTitle: 'deze afwezigheid',
  url: '/manage/driverabsences',
  apiUrl: '/driverabsences/',
  sortBy: ['date'],
  sortDesc: [true],
  deletable: false,
  editable: true,
  filterName: 'manage/driverabsences',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'driver_full_name',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Periode van', value: 'date_ge', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Periode tot', value: 'date_le', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Chauffeur', value: 'driver_id', type: 'optionList', optionListName: 'drivers', optionListParams: {is_active: true}, columns: 3, labelCols: 3, inputCols: 9}
  ],
  totalGroupFields: true,
  // newRecord: {
  // },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Naam', value: 'driver_full_name', link: '/manage/driverabsences/{id}', width: '20%'},
    {text: 'Datum', value: 'date', filter: 'date', width: '20%'},
    {text: 'Reden', value: 'reason', width: '20%'}
  ]
};
